import axios from "axios";
import jwt from "jwt-decode";
import {
  AUTH_URL,
  APP_URL,
  LOGIN_POST,
  LOGOUT_POST,
  RECOVERY_POST,
  RESET_POST,
} from "../constants";

const axiosClient = axios.create();
axiosClient.CancelToken = axios.CancelToken;
axiosClient.isCancel = axios.isCancel;

export const loginuser = (user, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    // if(user?.username==='admin@admin.com' && user?.password==='123456'){

    //     let response = {status: 200, data: {"access_token":"eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJUcXFXcE01V05RWG4ydW5UWDNiaGhRZnA5SEJHbGtfV050djZDOUhVTUljIn0.eyJleHAiOjE2MDkyMzY4MDksImlhdCI6MTYwOTIwMDgwOSwianRpIjoiYjdhYjA1NDUtNDA2Ni00NmI1LTkwZDYtNzQ5NzY5NjRkMmI2IiwiaXNzIjoiaHR0cHM6Ly9nY3AtbXV0dWFsc2VyLWtleWNsb2FrLWRldi5hcHBzcG90LmNvbS9hdXRoL3JlYWxtcy96b25hc2VyIiwiYXVkIjoiYWNjb3VudCIsInN1YiI6IjE4Njk2YWExLTgzZjAtNGJiZC05MDEwLWE0ODUzZDVjNmU3YiIsInR5cCI6IkJlYXJlciIsImF6cCI6InBvcnRhbCIsInNlc3Npb25fc3RhdGUiOiJlY2FlNzNiYS0zOTllLTQ1MDEtOTc0Mi01Zjg3NmYxZGUzODIiLCJhY3IiOiIxIiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHA6Ly9sb2NhbGhvc3Q6ODA4MC8qIiwiaHR0cHM6Ly9jbG91ZHktZmxhcmUtNDI2NzMwLnBvc3RtYW4uY28iLCJodHRwczovL2djcC1tdXR1YWxzZXIta2V5Y2xvYWstZGV2LmFwcHNwb3QuY29tIiwiKiIsImh0dHBzOi8vZ2NwLW11dHVhbHNlci16b25hc2VyLWRldi5hcHBzcG90LmNvbSJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsib2ZmbGluZV9hY2Nlc3MiLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoicHJvZmlsZSBlbWFpbCIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6IkpoYWRlciBQYWxvbWVxdWUiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJqaGFkZXIubW9yZW5vQGdtYWlsLmNvbSIsImdpdmVuX25hbWUiOiJKaGFkZXIiLCJ0eXBlIjoiRVhURVJOTyIsImZhbWlseV9uYW1lIjoiUGFsb21lcXVlIiwiZW1haWwiOiJqaGFkZXIubW9yZW5vQGdtYWlsLmNvbSJ9.RhdQdjjfTuppqM0vAurEx9q2srjxzD7UtlIe4qBVMWK9V3qiCRPKIjwpl6qwbm7-QdXX1I1NRCaUPNHCmR1FnXpF2YfxzL9WfsamCjBrhlYJoFcTq4WviG5JvEk7iyFgHf0-b_rFT8zHq1AOC1a1VuGby7NPUAeRD0qH48kqpDhFdWqzDRCMvNw2qN5RjnzGgjvvRnhfCRodK4IIXfV8EMlgiR2aax7vQ8HvrhRdN6YpwgP4QJ-6mJeUS52hzQoMQpEvWDXnR75SIvPzyqormQi6Z4Z2m4iZ0OLe6vJMeIUoVRM4t4FVagoCIcfBJ5flGH8sx7YcF3CDsQVn0WspOw","expires_in":36000,"refresh_expires_in":1800,"refresh_token":"eyJhbGciOiJIUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJhMzg3Y2I1MS0yMTI2LTRmNzItYTcxYy1jMTI4ZWNkYmRjOGUifQ.eyJleHAiOjE2MDkyMDI2MDksImlhdCI6MTYwOTIwMDgwOSwianRpIjoiNTZjMDM4ZGYtNjcxYi00MmRjLWE4MTItOGUxMDA1ZDM2MmZhIiwiaXNzIjoiaHR0cHM6Ly9nY3AtbXV0dWFsc2VyLWtleWNsb2FrLWRldi5hcHBzcG90LmNvbS9hdXRoL3JlYWxtcy96b25hc2VyIiwiYXVkIjoiaHR0cHM6Ly9nY3AtbXV0dWFsc2VyLWtleWNsb2FrLWRldi5hcHBzcG90LmNvbS9hdXRoL3JlYWxtcy96b25hc2VyIiwic3ViIjoiMTg2OTZhYTEtODNmMC00YmJkLTkwMTAtYTQ4NTNkNWM2ZTdiIiwidHlwIjoiUmVmcmVzaCIsImF6cCI6InBvcnRhbCIsInNlc3Npb25fc3RhdGUiOiJlY2FlNzNiYS0zOTllLTQ1MDEtOTc0Mi01Zjg3NmYxZGUzODIiLCJzY29wZSI6InByb2ZpbGUgZW1haWwifQ.C06joJ_Rsyr-LAhecWzBT_5nWaEsnxMeirjaV3TIyik","token_type":"bearer","not-before-policy":0,"session_state":"ecae73ba-399e-4501-9742-5f876f1de382","scope":"profile email"}}
    //     dispatch({ type: "LOGIN_SESSION", session: response.data, authenticated: true });
    //     resolve(response)
    axiosClient
      .post(`${APP_URL}/user${LOGIN_POST}`, user, headers)
      .then((response) => {
        if (response.data) {
          const permissions = SortUserInfo(response?.data?.userInfo?.roleList);
          dispatch({
            type: "LOGIN_SESSION",
            session: response.data,
            authenticated: true,
            username: user.username,
            infoToken: jwt(response.data.access_token),
            permissions: permissions,
            userInfo: { ...response?.data?.userInfo },
          });
        }
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {
          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema de CORS comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

const SortUserInfo = (roleList = []) => {
  let permissions = [];
  for (let x of roleList) {
    for (let y of x?.moduleList) {
      const result = permissions?.find((p) => p?.code === y?.code);

      if (!result) {
        permissions.push({
          code: y?.code,
          description: y?.description,
          functionalities: [...y?.functionalityList].map((x) => x.code),
        });
      }
    }
    const home = permissions?.push({ code: "HOME", description: "HOME" });
  }
  return permissions;
};

export const logoutUser = (dispatch, refresh_token) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    let refreshToken = {
      refreshToken: refresh_token,
    };
    axiosClient
      .post(`${AUTH_URL}${LOGOUT_POST}`, refreshToken, headers)
      .then((response) => {
        dispatch({
          type: "LOGOUT",
          session: response.data,
          authenticated: false,
        });
        resolve(response);
      })
      .catch((error) => {
        dispatch({ type: "LOGOUT", session: "", authenticated: false });
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        resolve(error.response);
      });
  });
};

export const forgotPassword = (email, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    axiosClient
      .post(`${AUTH_URL}${RECOVERY_POST}`, { email: email }, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const resetPassword = (usuario, tokenResetPass, dispatch) => {
  const newUser = usuario;
  if (usuario.hasOwnProperty("showPassword")) {
    delete newUser.showPassword;
  }
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    axiosClient
      .post(`${AUTH_URL}${RESET_POST}?key=${tokenResetPass}`, newUser, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        if (typeof error.response === "undefined") {

          reject({
            error: "technical_error",
            error_description:
              "Occurió un problema comuniquese con el administrador.",
          });
        }
        reject(error.response);
        resolve(error.response);
      });
  });
};
